/* eslint-disable */
import Vue from 'vue'
import draggable from './draggable'


function plugin (Vue, options) {
    if (plugin.installed) {
      return
    }
  
    Vue.directive('draggable', draggable)
}

export default plugin


// WEBPACK FOOTER //
// ./src/_fdp/core/directive/drag/index.js